import { render, staticRenderFns } from "./videoConfSectionFooter.vue?vue&type=template&id=7bb7bef2&scoped=true&lang=pug&"
import script from "./videoConfSectionFooter.vue?vue&type=script&lang=js&"
export * from "./videoConfSectionFooter.vue?vue&type=script&lang=js&"
import style0 from "./videoConfSectionFooter.vue?vue&type=style&index=0&id=7bb7bef2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb7bef2",
  null
  
)

export default component.exports